// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"SendEmail_FullWidth__3A5IQ","FormLabel":"SendEmail_FormLabel__1ls_0","LoadingContainer":"SendEmail_LoadingContainer__2lYuY","TextAlert":"SendEmail_TextAlert__UDXfH"};